import { MainDashBoardSection } from 'src/app/Constants/main-dashboard-sections.constants';

export const reconciliationsDashboardSections: MainDashBoardSection[] = [
  {
    name: 'VVV verwerking',
    icon: 'running_with_errors', // was price_check
    path: 'reconciliations',
  },
];
